export const setManualCash = ({ commit }, payload) => {
  commit('SET_MANUAL_CASH', payload)
}
export const addManualCash = ({ commit }, payload) => {
  commit('ADD_MANUAL_CASH', payload)
}
export const setManualCashLoading = ({ commit }, payload) => {
  commit('SET_MANUAL_CASH_LOADING', payload)
}
export const setRevenueByArea = ({ commit }, payload) => {
  commit('SET_REVENUE_BY_AREA', payload)
}
export const setRevenueByAreaLoading = ({ commit }, payload) => {
  commit('SET_REVENUE_BY_AREA_LOADING', payload)
}
export const setRevenueByProduct = ({ commit }, payload) => {
  commit('SET_REVENUE_BY_PRODUCT', payload)
}
export const setRevenueByProductLoading = ({ commit }, payload) => {
  commit('SET_REVENUE_BY_PRODUCT_LOADING', payload)
}
export const setProfessional = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL', payload)
}
export const setProfessionalLoading = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_LOADING', payload)
}

export const setProfessionalKpis = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_KPIS', payload)
}
export const setProfessionalKpisLoading = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_KPIS_LOADING', payload)
}

export const setDfc = ({ commit }, payload) => {
  commit('SET_DFC', payload)
}
export const setDfcLoading = ({ commit }, payload) => {
  commit('SET_DFC_LOADING', payload)
}

export const setRevenueAreas = ({ commit }, payload) => {
  commit('SET_REVENUE_AREAS', payload)
}
export const setRevenueAreasLoading = ({ commit }, payload) => {
  commit('SET_REVENUE_AREAS_LOADING', payload)
}

export const setFilials = ({ commit }, payload) => {
  commit('SET_FILIALS', payload)
}
export const setFilialsLoading = ({ commit }, payload) => {
  commit('SET_FILIALS_LOADING', payload)
}

export const setProfessionalDre = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_DRE', payload)
}
export const setProfessionalDreLoading = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_DRE_LOADING', payload)
}

export const setBalance = ({ commit }, payload) => {
  commit('SET_BALANCE', payload)
}
export const setBalanceLoading = ({ commit }, payload) => {
  commit('SET_BALANCE_LOADING', payload)
}

export const setTeam = ({ commit }, payload) => {
  commit('SET_TEAM', payload)
}
export const setTeamLoading = ({ commit }, payload) => {
  commit('SET_TEAM_LOADING', payload)
}

export const setLastUpdateReference = ({ commit }, payload) => {
  commit('SET_LAST_UPDATE_REFERENCE', payload)
}
export const addLastUpdateReference = ({ commit }, payload) => {
  commit('ADD_LAST_UPDATE_REFERENCE', payload)
}
export const setLastUpdateReferenceLoading = ({ commit }, payload) => {
  commit('SET_LAST_UPDATE_REFERENCE_LOADING', payload)
}
export const setComparative = ({ commit }, payload) => {
  commit('SET_COMPARATIVE', payload)
}
export const addComparative = ({ commit }, payload) => {
  commit('ADD_COMPARATIVE', payload)
}
export const setComparativeLoading = ({ commit }, payload) => {
  commit('SET_COMPARATIVE_LOADING', payload)
}

export const setFilters = ({ commit }, payload) => {
  commit('SET_FILTERS', payload)
}
export const setComissionBpo = ({ commit }, payload) => {
  commit('SET_COMISSION_BPO', payload)
}
export const addComissionBpo = ({ commit }, payload) => {
  commit('ADD_COMISSION_BPO', payload)
}
export const setComissionBpoLoading = ({ commit }, payload) => {
  commit('SET_COMISSION_BPO_LOADING', payload)
}

export const setDreVersion = ({ commit }, payload) => {
  commit('SET_DRE_VERSION', payload)
}
export const setDreVersionLoading = ({ commit }, payload) => {
  commit('SET_DRE_VERSION_LOADING', payload)
}

export const setDreComparative = ({ commit }, payload) => {
  commit('SET_DRE_COMPARATIVE', payload)
}
export const setDreComparativeLoading = ({ commit }, payload) => {
  commit('SET_DRE_COMPARATIVE_LOADING', payload)
}

export const setDfcComparative = ({ commit }, payload) => {
  commit('SET_DFC_COMPARATIVE', payload)
}
export const setDfcComparativeLoading = ({ commit }, payload) => {
  commit('SET_DFC_COMPARATIVE_LOADING', payload)
}

